import React from 'react';
import { StyleSheet, View } from 'react-native';

import { SPACING } from '@garnish/constants';
import { Modal } from '../../Modal';
import {
  ModalCloseBtn,
  ModalHeadline,
  ModalSubhead,
} from '../../Modal.subcomponents';

export const ModalDialogue = (props: ModalDialogueProps) => {
  const {
    children,
    shouldHideCloseBtn,
    headline,
    subhead,
    onRequestClose,
    ...modalProps
  } = props;

  return (
    <Modal onRequestClose={onRequestClose} {...modalProps}>
      {shouldHideCloseBtn ? (
        <View style={styles.dialogueWithTopSpacer} />
      ) : (
        <ModalCloseBtn onPress={onRequestClose} />
      )}

      {headline ? <ModalHeadline>{headline}</ModalHeadline> : null}
      {subhead ? <ModalSubhead>{subhead}</ModalSubhead> : null}

      {children}
    </Modal>
  );
};

//
// ─── TYPES ──────────────────────────────────────────────────────────────────────
//

type ModalDialogueProps = {
  readonly shouldHideCloseBtn?: boolean;
  readonly headline?: string;
  readonly subhead?: string;
} & React.ComponentProps<typeof Modal>;

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const styles = StyleSheet.create({
  dialogueWithTopSpacer: {
    paddingTop: SPACING.large,
  },
});
